import { Directive } from '@angular/core';

@Directive({
  selector: '[nbPrefix]',
})
export class NbPrefixDirective {
}
